import { ensureInstallation } from './npm-dyn-dependencies'
import webpack from "webpack"
import CopyWebpackPlugin from 'copy-webpack-plugin'
import webpackMerge from 'webpack-merge'
// import HardSourceWebpackPlugin from 'hard-source-webpack-plugin'
import { fileExists, thereIsAnyFileMatching } from './utils'
import WebpackOnBuildPlugin from 'on-build-webpack'
import fs from 'fs-extra'

import _ENTRIES from './technologies/entries'
import _RESOLVERS from './technologies/resolvers'
import _OUTPUT from './technologies/output'
import _OPTMIZERS from './technologies/optimizations'
import _ESLINT from './technologies/eslint'
import _STYLE_LINT from './technologies/style-lint'
import _JS from './technologies/js'
import _PERF from './technologies/perf'
import _React from './technologies/react'
import _VUE from './technologies/vue'
import _COFFEE from './technologies/coffee-script'
import _TYPE_SCRIPT from './technologies/type-script'
import _MARKUPS from './technologies/markups'
import _MARKUDOWNS from './technologies/markdown'
import _ICONS from './technologies/icons'
import _HTML from './technologies/html'
import _HTTP from './technologies/http'
import _JSON from './technologies/json'
import _IMAGES from './technologies/images'
import _SPRITES from './technologies/sprites'
import _CRITICAL from './technologies/critical'
import _IMG_OPTMIZE from './technologies/optimize-images'
import _INCLUDE_ASSETS from './technologies/include-assets'
import { CSS as _CSS, SASS as _SCSS, LESS as _LESS, STYLUS as _STYLUS } from './technologies/styles'

// import ExtractTextPlugin from "extract-text-webpack-plugin"
// import FaviconsWebpackPlugin from "favicons-webpack-plugin"
// //////// import postCSSNext from 'postcss-cssnext'
// //////// import reactCSSModules from 'babel-plugin-react-css-modules'
// import HtmlWebpackPlugin from 'html-webpack-plugin'
// //////// import HtmlWebpackHarddiskPlugin from 'html-webpack-harddisk-plugin'
// //////// import HtmlReloadPlugin from 'reload-html-webpack-plugin'
// //////// import UglifyJSPlugin from 'uglifyjs-webpack-plugin'
// import CompressionPlugin from "compression-webpack-plugin"
// import ImageminPlugin from 'imagemin-webpack-plugin'
// import imageminPngcrush from 'imagemin-pngcrush'
// import imageminMozjpeg from 'imagemin-mozjpeg'
// //////// import imageminWebp from 'imagemin-webp'
// import ResourceHintWebpackPlugin from 'resource-hints-webpack-plugin'
// import HtmlWebpackExcludeAssetsPlugin from 'html-webpack-exclude-assets-plugin'
// import HtmlWebpackIncludeAssetsPlugin from 'html-webpack-include-assets-plugin'
// //////// import WrapperPlugin from 'wrapper-webpack-plugin'
// import SpritesmithPlugin from 'webpack-spritesmith'
// //////// const CriticalPlugin = require('webpack-plugin-critical').CriticalPlugin

// // // // // // // // import WebpackOnBuildPlugin from 'on-build-webpack'

// import critical from 'critical'
// import StyleLintPlugin from 'stylelint-webpack-plugin'

import path from 'path'

const deepMerge = webpackMerge.smart

export default async function configureClient (opts, state, appRef) { 
  
  const {
    COMMON_CONFIG,
    SRC_PATH,
    OUTPUT_PATH,
    IS_DEV,
    PROJECT_PATH,
    FURTHER_PATH,
    // USED_EXTENSIONS,
    FURTHER_REF
  } = state
  
  const USED_EXTENSIONS = new Set(await thereIsAnyFileMatching(SRC_PATH, [
      '.js', '.css', '.html',
      '.jsx', '.vue', '.ts', '.tsx', '.coffee',
      '.scss', '.less', '.styl',
      '.htm', '.tpl', '.md'
  ]))
  
  const USED_EXTENSIONS_LIST = Array.from(USED_EXTENSIONS).join('|')

  opts = opts || {}
  opts.custom = opts.custom || {}

  let FILES_TO_APPEND = []

  async function ensureInstall (what) {
    return await ensureInstallation(what, null,
    {
      verbose: true,
      installing: opts.installing
      // node_modules: FURTHER_REF
    })
  }

  // we have to install all the dependencyes for projects
  // that use a client side interface
  await ensureInstall('client')
  
  return new Promise (async (resolve, reject) => {
    const CLIENT_CONFIG = {}

    // client is a target for web environments
    CLIENT_CONFIG.target = 'web'

    // initiating an empty plugins list
    CLIENT_CONFIG.plugins = []

    // we will have a default entry point for the webapp
    CLIENT_CONFIG.entry = _ENTRIES(state)

    // also, let's create a bundle for each component (code splitting)
    // CLIENT_CONFIG.entry = Object.assign({}, CLIENT_CONFIG.entry,
      // getEntries(SRC_PATH, `${SRC_PATH}/client/components/**/index.*`)
    // )

    // we gotta set the output based on the each name
    CLIENT_CONFIG.output = _OUTPUT(state)

    // let's also accept a source maps
    if (IS_DEV) {
      CLIENT_CONFIG.devtool = 'source-map'
      CLIENT_CONFIG.output.hotUpdateChunkFilename = 'hot/[hash].hot.js'
      CLIENT_CONFIG.output.hotUpdateMainFilename = 'hot/[hash].hot.json'
    } else {
      if (opts.production && opts.production.sourceMaps) {
        CLIENT_CONFIG.devtool = 'source-map'
      }
    }
  
    // Measuring and validating file sizes
    if (IS_DEV) {
      // we install any dependency used for development
      await ensureInstall('developer')
      CLIENT_CONFIG.performance = _PERF
    }

    // preparing the home for rules
    CLIENT_CONFIG.module = { rules: [], loaders: [] }
    
/**
 * Basic files
 * 
 * These are basic dependencies and configurations we
 * know we are going to use for sure.
 */
    // ESLint
    CLIENT_CONFIG.module.rules.push(_ESLINT(state, opts))

    // rules for javascript (es6+, linter, generators, etc)
    CLIENT_CONFIG.module.rules.push(_JS(state))

    // rules for css (lint, extractors, etc)
    CLIENT_CONFIG.module.rules.push(_CSS(state, CLIENT_CONFIG))

    // Here we can also specify some aliases and where
    // to find some of the modules
    CLIENT_CONFIG.resolve = _RESOLVERS(state)

/**
 * Styles applied to client
 * 
 * Technologies used to apply styles to pages.
 */
    // SASS/SCSS
    if (USED_EXTENSIONS.has('.scss')) {
      await ensureInstall('sass')
      CLIENT_CONFIG.module.rules.push(_SCSS(state, CLIENT_CONFIG))
    }

    // LESS
    if (USED_EXTENSIONS.has('.less')) {
      await ensureInstall('less')
      CLIENT_CONFIG.module.rules.push(_LESS(state, CLIENT_CONFIG))
    }

    // STYLUS
    if (USED_EXTENSIONS.has('.styl')) {
      await ensureInstall('stylus')
      CLIENT_CONFIG.module.rules.push(_STYLUS(state, CLIENT_CONFIG))
    }

/**
 * Possible script technologies
 * 
 * These scripts and dependencies will be installed and
 * loaded only if/when their respective files get used.
 */
    // REACT
    if (USED_EXTENSIONS.has('.jsx')) {
      CLIENT_CONFIG.module.rules.push(_React(state))
      new webpack.ProvidePlugin({
        h: path.resolve(FURTHER_REF, '../', '.meta/preact.h.js')
      })
    }

    // VUEJS
    if (USED_EXTENSIONS.has('.vue')) {
      await ensureInstall('vue')
      CLIENT_CONFIG.module.rules.push(_VUE(state))
    }

    // COFFEE SCRIPT
    if (USED_EXTENSIONS.has('.coffee')) {
      await ensureInstall('coffee')
      CLIENT_CONFIG.module.rules.push(_COFFEE(state))
    }

    // TYPE SCRIPT
    if (USED_EXTENSIONS.has('.ts') || USED_EXTENSIONS.has('.tsx')) {
      await ensureInstall('typescript')
      CLIENT_CONFIG.module.rules.push(_TYPE_SCRIPT(state))
    }

    // // TODO: Add support for angular

/**
 * Markup files
 * 
 * These are dependencies related to markup files such
 * as html or other template engines.
 */
    if (USED_EXTENSIONS_LIST.match(/\.(htm(l)?|xhtm(l)?|hbs|handlebars|ejs|mustache|nunjucks|tpl)/)) {
      CLIENT_CONFIG.module.rules.push(_MARKUPS(state))
    }

/**
 * JSON and JSON5
 * 
 * We will actually always use JSON5 for any JSON file.
 */
    if (USED_EXTENSIONS.has('.json')
      || USED_EXTENSIONS.has('.json5')) {
      await ensureInstall('json')
      CLIENT_CONFIG.module.rules.push(_JSON(state))
    }

/**
 * Texts and MarkDowns
 * 
 * We will treat all these files as markdown.
 */
    if (USED_EXTENSIONS.has('.txt')
      || USED_EXTENSIONS.has('.md')) {
      CLIENT_CONFIG.module.rules.push(_MARKUDOWNS(state))
    }

/**
 * Interpolating the HTMLs
 * 
 * Will interpolate html files and apply some attributes
 * to allow it to lazy load images
 */
    if (await thereIsAnyFileMatching(SRC_PATH, ['.html', '.htm', '.tpl'])) {
      CLIENT_CONFIG.module.rules.push(_HTML(state, opts, CLIENT_CONFIG))
    }

/**
 * Images
 * 
 * We will also treat all the images, optimizing them
 * the best we can, copying them to the assets directory.
 */
    if(USED_EXTENSIONS_LIST.match(/\.(png|jp(e)?g|gif|webp|svg|ttf|woff|woff2)/)) {
      // there are images to be treated
      CLIENT_CONFIG.module.rules.push(_IMAGES(state, CLIENT_CONFIG))

      // optimizing images
      // This is disabled by default during development
      if (!IS_DEV || opts.development.optmizeImages){
        await ensureInstall('imageOptimization')
        CLIENT_CONFIG.plugins.push(_IMG_OPTMIZE(state, opts, CLIENT_CONFIG))
      }
    }

/**
 * CopyWebpackPlugin
 * 
 * This plugin triggers errors when a file (not a glob)
 * does not exist. So, we need to treat it.
 */
    async function copyIfExists (src, dest) {
      let fullSrc = path.join(SRC_PATH, src)
      if (src.indexOf('**') < 0 && !await fileExists(fullSrc)) {
        return // nothing to copy
      }
      CLIENT_CONFIG.plugins.push(
        new CopyWebpackPlugin([
          {
            from: fullSrc,
            to: path.join(OUTPUT_PATH, dest || src),
            ignore: ['**/**/.DS_Store', '**/**/.gitkeep']
          }
        ])
      )
    }

    // let's ensure we will copy any assets
    copyIfExists('client/public/')
    copyIfExists('client/main/assets', 'client/assets')
    copyIfExists('client/components/**/assets')

    // copying a basic version for the http-server
    CLIENT_CONFIG.plugins.push(_HTTP(state, opts, CLIENT_CONFIG))
    

    // plugin for hotModuleReplacement
    CLIENT_CONFIG.plugins.push(new webpack.HotModuleReplacementPlugin())
    
    // ignoring some files
    CLIENT_CONFIG.plugins.push(new webpack.IgnorePlugin(/\.DS_Store$/, /node_modules/, /\.log/, /^\~.*/, /\.tmp$/, /\.git/))

    // // treating icons (it will also remove other unused assets)
    if (opts.icon) {
      CLIENT_CONFIG.plugins.push(_ICONS(state, opts, CLIENT_CONFIG))
    }

    // treating sprites
    if (await thereIsAnyFileMatching(SRC_PATH, ['.png', '.jpg', '.jpeg'], { path: '**/sprites/' })) {
      // if there is any directory "sprites" with images in it
      CLIENT_CONFIG.plugins.push(_SPRITES(state, opts, CLIENT_CONFIG))
      FILES_TO_APPEND.push('sprites/sprite.css')
    }

    // critical path plugin
    // will generate index-critical.html with the basic structure and inlined styles and scripts
    CLIENT_CONFIG.plugins.push(_CRITICAL(state, opts, CLIENT_CONFIG))

    // Appending and prepending files into html
    if (FILES_TO_APPEND.length) {
      // TODO: AQUI: prepend reset.css
      _INCLUDE_ASSETS({ FILES_TO_APPEND }, opts, CLIENT_CONFIG)
    }

    // caching modules to make next builds faster
    // CLIENT_CONFIG.plugins.push(new HardSourceWebpackPlugin({
    //   cacheDirectory: path.resolve(PROJECT_PATH, '.further/.cache/hard-source/[confighash]'),
    //   recordsPath: path.resolve(PROJECT_PATH, '.further/.cache/hard-source/[confighash]/records.json')
    // }))

    // use es-lint for style files
    CLIENT_CONFIG.plugins.push(_STYLE_LINT(state))

/**
 * Optimizations
 * 
 * Let's optimize images, scripts and styles
 */
    if (!IS_DEV || opts.development.optimize) {
      // if in production (or if should optimize
      // we set some flags
      CLIENT_CONFIG.plugins.push(new webpack.DefinePlugin({
        'process.env': {
            NODE_ENV: '"production"'
        }
      }))
    }

    // Extra optmizations
    if (!IS_DEV || opts.development.optimize) {
      _OPTMIZERS(state, opts, CLIENT_CONFIG)
    }

    CLIENT_CONFIG.plugins.push(new WebpackOnBuildPlugin(async function(stats) {
      // unless the user has disabled it, we start an HTTP Server
      if (appRef.onBuildDone) {
        appRef.onBuildDone('client', null, stats)
      }
    }))

    CLIENT_CONFIG.name = 'client-config'

    // we have to remove all the invalid/empty plugins that may
    // have been accidently added
    CLIENT_CONFIG.plugins = CLIENT_CONFIG.plugins.filter(
      plugin => plugin && (Object.keys(plugin).length || plugin.apply)
    )

    // time to resolve with the processed config for the webpack
    // merged with into the default settings
    resolve(deepMerge({}, COMMON_CONFIG, CLIENT_CONFIG))
    

















//     if (USED_EXTENSIONS.has('.vue')) {
//       CLIENT_CONFIG.module.rules.push({
//         test: /\.vue$/,
//         // use: [
//         //   // { loader: FURTHER_REF + 'vue-style-loader' },
//         //   // { loader: FURTHER_REF + 'style-loader' },
//         //   // { loader: FURTHER_REF + 'css-loader' },
//         //   // { loader: FURTHER_REF + 'less-loader' },
//         //   // { loader: FURTHER_REF + 'styl-loader' },
//         //   // { loader: FURTHER_REF + 'sass-loader' },
//         //   // { loader: FURTHER_REF + 'babel-loader' },
//         //   { loader: FURTHER_REF + 'vue-html-loader' },
//         // ],

//         loader: FURTHER_REF + 'vue-loader',
//         options: {
//           // presets: [
//           //   [ FURTHER_REF + 'babel-preset-es2015', { loose: true, modules: false } ],
//           //   FURTHER_REF + 'vue-loader'
//           // ],
//           loaders: {
//             js: FURTHER_REF + 'babel-loader',
//             css: FURTHER_REF + 'vue-style-loader!'+ FURTHER_REF +'css-loader'
//             // css: FURTHER_REF + 'vue-style-loader'
//           },
//           // extractCSS: true,
//           // postcss: [postCSSNext()]
//         }
//       })
//     }

//     // rules for react (preact)
//     if (USED_EXTENSIONS.has('.jsx')) {
//       CLIENT_CONFIG.module.rules.push({
//         test: /\.jsx$/,
//         // loaders: ['react-hot', 'babel-loader'],
//         loader: FURTHER_REF + 'babel-loader',
//         // FURTHER_REF + 'babel-loader',
//         // loader: `${ FURTHER_REF }react-loader?presets[]=${ FURTHER_REF }react!${ FURTHER_REF }babel-preset-es2015?` + JSON.stringify({),
//         exclude: /node_modules/,
//         options: {
//           plugins: [
//             [FURTHER_REF + "babel-plugin-transform-decorators-legacy"],
//             [FURTHER_REF + "babel-plugin-transform-react-jsx", { "pragma": "require('preact').h" }]
//           ],
//           presets: [
//             [ FURTHER_REF + "babel-preset-preact" ],
//             // [ FURTHER_REF + "babel-reset-preact/lib" ],
//             [ FURTHER_REF + 'babel-preset-es2015', { loose: true, modules: false } ]//,
//           ]
//         }
//       })
//       new webpack.ProvidePlugin({
//         h: path.resolve(FURTHER_REF, '../', '.meta/preact.h.js')
//       })
//     }

//     // rules for coffee script
//     if (USED_EXTENSIONS.has('.coffee')) {
//       CLIENT_CONFIG.module.rules.push({
//         test: /\.coffee$/,
//         // loader: require('coffee-loader?sourceMap=true') // coffeeLoader('!sourceMap=true')
//         use: [
//           {
//             loader: FURTHER_REF + 'coffee-loader',
//             options: { sourceMap: true }
//           }
//         ],
//         exclude: /node_modules/
//       })
//     }

//     // rules for typescript
//     if (USED_EXTENSIONS.has('.ts') || USED_EXTENSIONS.has('.tsx')) {
//       CLIENT_CONFIG.module.rules.push({
//         test: /\.ts(x?)$/,
//         loader: `${ FURTHER_REF }babel-loader?presets[]=${ FURTHER_REF }babel-preset-es2015!${ FURTHER_REF }ts-loader?` + JSON.stringify({
//             configFile: path.resolve(FURTHER_REF, '../', '.meta/tsconfig.json')
//         }),
//         exclude: /node_modules/
//       })
//     }
    
//     // rules for markups
//     CLIENT_CONFIG.module.rules.push({
//       test: /\.(htm|html|xhtml|hbs|handlebars|ejs|mustache|nunjucks)$/,      
//       loader: FURTHER_REF + 'htmllint-loader',
//       query: {
//         config: path.resolve(FURTHER_REF, '../', '.htmllintrc'),
//         failOnError: true,
//         failOnWarning: true
//       },
//       exclude: /node_modules/
//     })

//     // JSON/JSON5
//     CLIENT_CONFIG.module.rules.push({
//       test: /\.(json5|json)$/,
//       loader: FURTHER_REF + 'json5-loader',
//       exclude: /node_modules/
//     })

//     // Markdown and Texts
//     CLIENT_CONFIG.module.rules.push({
//       test: /\.(txt|md)$/,
//       loaders: [
//         FURTHER_REF + 'raw-loader'
//       ],
//       exclude: /node_modules/
//     })

//     CLIENT_CONFIG.module.rules.push({
//       test: /\.(html|htm)$/,
//       use: {
//         loader: FURTHER_REF + 'html-loader?interpolate',
//         options: {
//           attrs: [':data-src']
//         }
//       }
//     })
//     // RULES FOR STYLES
//     const CSS_LOADER = {
//       loader: FURTHER_REF + 'css-loader',
//       options: {
//           sourceMap: true,
//           minimize: !IS_DEV
//           // importLoaders: 1
//       }
//     }
//     const POST_CSS = {
//       loader: FURTHER_REF + 'postcss-loader',
//       options: {
//         sourceMap: true,
//         cssnext: true,
//         autoprefixer: true,
//         cssnano: true,
//         config: {
//           path: path.resolve(FURTHER_REF, '../', '.meta/postcss.config.js')
//         }
//       }
//     }
//     const RESOLVE_URL = {
//       loader: FURTHER_REF + 'resolve-url-loader',
//       options: {
//         limit: 10240
//       }
//     }
//     const STYLE_LOADER = {
//       loader: FURTHER_REF + 'style-loader',
//       options: {
//           sourceMap: true,
//           minimize: !IS_DEV,
//           importLoaders: 1,
//           discardComments: IS_DEV ? false : { removeAll: true },
//       }
//     }
//     // rules for css
//     CLIENT_CONFIG.module.rules.push({
//       test: /\.css$/,
//       // exclude: [/node_modules/],
//       use: ExtractTextPlugin.extract({
//         fallback: STYLE_LOADER,
//         use: [
//           CSS_LOADER,
//           RESOLVE_URL,
//           POST_CSS
//         ]
//       })
//     })

//     // rules for sass
//     if (USED_EXTENSIONS.has('.scss')) {
//       CLIENT_CONFIG.module.rules.push({
//         test: /\.(sass|scss)$/,
//         exclude: [/node_modules/],
//         use: ExtractTextPlugin.extract({
//           fallback: STYLE_LOADER,
//           use: [
//             CSS_LOADER,
//             RESOLVE_URL,
//             {
//               loader: FURTHER_REF + 'sass-loader',
//               options: {
//                   sourceMap: true
//               }
//             },
//             POST_CSS
//           ]
//         })
//       })
//     }
//     // rules for less
//     if (USED_EXTENSIONS.has('.less')) {
//       CLIENT_CONFIG.module.rules.push({
//         test: /\.less$/,
//         exclude: [/node_modules/],
//         use: ExtractTextPlugin.extract({
//           fallback: STYLE_LOADER,
//           use: [
//             CSS_LOADER,
//             RESOLVE_URL,
//             {
//               loader: FURTHER_REF + "less-loader",
//               options: {
//                   sourceMap: true
//               }
//             },
//             POST_CSS
//           ]
//         })
//       })
//     }
//     // ryles for stylus
//     if (USED_EXTENSIONS.has('.styl')) {
//       CLIENT_CONFIG.module.rules.push({
//         test: /\.(styl)$/,
//         // exclude: [/node_modules/],
//         use: ExtractTextPlugin.extract({
//           fallback: STYLE_LOADER,
//           use: [
//             // STYLE_LOADER,
//             CSS_LOADER,
//             // RESOLVE_URL,
//             {
//               loader: `${FURTHER_REF}stylus-loader`,
//               options: {
//                 // paths: `${FURTHER_REF}bootstrap-stylus/stylus/`
//                 paths: `${FURTHER_REF}bootstrap-styl`
//               }
//             }//,
//             // POST_CSS
//           ]
//         })
//       })
//     }
//     // a loader for the images. It will treat the way they are loaded/referenced/embeded in your files
//     CLIENT_CONFIG.module.rules.push({
//       test: /\.(png|jp(e)?g|gif|webp|svg)$/,
//       use: [
//         {
//           loader: FURTHER_REF + 'file-loader',
//           options: {
//             name: 'assets/[name]-[hash].[ext]' //,
//             // publicPath: 'public'
//           }
//         }
//       ]
//     })
//     // webpack must know how to resolve these files
//     CLIENT_CONFIG.resolve = {
//       extensions: [
//         ".webpack.js", ".web.js", ".js", ".ts", ".tsx", ".jsx",
//         "jpg", "png", "gif", "webp", "jpeg", "jpg", "svg",
//         ".html", ".tpl",
//         ".css", ".less", ".styl", ".sass", ".vue"
//       ], //, ".mjs", ".coffee", ".less", ".styl", ".sass" ],
//       alias: {
//         react: 'preact-compat',
//         'react-dom': 'preact-compat',
//         'react-addons-css-transition-group': 'react-addons-css-transition-group',
//         vue: 'vue',
//         Components: path.resolve(PROJECT_PATH, 'src/client/components/'),
//         Comps: path.resolve(PROJECT_PATH, 'src/client/components/'),
//         // Sprites: path.resolve(PROJECT_PATH, 'dist/sprites/sprite.css'),
//         Main: path.resolve(PROJECT_PATH, 'src/client/main/'),
//         Utils: path.resolve(PROJECT_PATH, 'src/isomorphic/'),
//         Templates: path.resolve(PROJECT_PATH, 'src/templates/')
//       },
//       modules: [
//         'furtherjs/node_modules',
//         'node_modules/furtherjs/node_modules',
//         'node_modules',
//         'spritesmith-generated'
//       ]
//     }
//     // const EventsPlugin = function() {};
//     // EventsPlugin.prototype.apply = function(compiler) {
//     //     compiler.plugin('after-plugins', function(watching) {
//     //         console.log('>>>>> PLUGIN RODOU');
//     //         // cb();
//     //     });
//     // };

    // the plugins
    
//     // CLIENT_CONFIG.plugins.push(new EventsPlugin())

    // if (!await fileExists(`${OUTPUT_PATH}/client/public/`)
    //   && await fileExists(`${SRC_PATH}/client/public/`)) {
    //     CLIENT_CONFIG.plugins.push(
    //       new CopyWebpackPlugin([
    //         {
    //           from: `${SRC_PATH}/client/public/`,
    //           to: `${OUTPUT_PATH}/client/public/`,
    //           ignore: ['**/**/.DS_Store', '**/**/.gitkeep']
    //         }
    //       ])
    //     )
    // }
    // if (!await fileExists(`${OUTPUT_PATH}/client/main/assets`)
    //   && await fileExists(`${SRC_PATH}/client/main/assets`)) {
    //     CLIENT_CONFIG.plugins.push(
    //       new CopyWebpackPlugin([
    //         {
    //           from: `${SRC_PATH}/client/main/assets`,
    //           to: `${OUTPUT_PATH}/client/main/assets`,
    //           ignore: ['**/**/.DS_Store', '**/**/.gitkeep']
    //         }
    //       ])
    //     )
    // }
//     CLIENT_CONFIG.plugins.push(
//       new CopyWebpackPlugin([
//         {
//           from: `${SRC_PATH}/client/public/`,
//           to: `${OUTPUT_PATH}/client/`,
//           ignore: ['**/**/.DS_Store']
//         },
//         {
//           from: `${SRC_PATH}/client/main/assets`,
//           to: `${OUTPUT_PATH}/client/main/assets`,
//           ignore: ['**/**/.DS_Store']
//         },
//         {
//           from: `${SRC_PATH}/client/components/**/assets`,
//           to: `${OUTPUT_PATH}/client/components/assets`,
//           ignore: ['**/**/.DS_Store']
//         }
//       ])
//     )
//     // CLIENT_CONFIG.plugins.push(new UglifyJSPlugin())

//     // treating HTML and templates
//     CLIENT_CONFIG.plugins.push(new webpack.IgnorePlugin(/\.DS_Store$/, /node_modules/, /\.log/))
//     CLIENT_CONFIG.plugins.push(new HtmlWebpackPlugin({
//       title: opts.name || 'index',
//       filename: 'main/index.html',
//       template: './src/client/main/templates/index.html',
//       templates: [
//           // './src/client/main/templates/index.html',
//           './src/client/components/**/*.html',
//       ],
//       inject: true,
//       excludeAssets: [/style([\.\-].*)?\.js/, /\.DS_Store/],
//       minify: IS_DEV ? false : {
//         caseSensitive: true,
//         collapseBooleanAttributes: true,
//         collapseWhitespace: true,
//         conservativeCollapse: true,
//         minifyCSS: true,
//         minifyJS: true,
//         removeAttributeQuotes: true,
//         removeComments: true,
//         removeScriptTypeAttributes: true,
//         removeStyleLinkTypeAttributes: true,
//         sortAttributes: true,
//         sortClassName: true,
//         useShortDoctype: true
//       },
//       chunksSortMode: function (chunk1, chunk2) {
//         /**
//          * We will sort the dependencies following these rules:
//          * 
//          * - Vendors come first (for rests and libs for exampe)
//          * - Main styles come first
//          * - Component styles come second (taking care of precedences)
//          * - Main scripts come first
//          * - Component scripts come later
//          */
//         const chunkPart1 = chunk1.names[0]
//         const chunkPart2 = chunk2.names[0]
//         if (chunkPart1.startsWith('vendor')) {
//           return -9
//         }
//         if (chunkPart2.startsWith('vendor')) {
//           return 9
//         }
//         if (chunkPart1.startsWith('main')) {
//           if (chunkPart1.endsWith('.js')) {
//             return -2
//           }
//           return -5
//         }
//         if (chunkPart2.startsWith('main')) {
//           if (chunkPart2.endsWith('.js')) {
//             return 2
//           }
//           return 5
//         }
//         return -1
//         // let order2 = orders.indexOf(chunk2.names[0]);

//         // return order1 - order2;
//       },
//       prefetch: ['**/*.woff'],
//       preload: ['/vendors/**/*.js', '/main/**/*.js', '/main/**/*.css'],
//       alwaysWriteToDisk: true,
//       chunks: {
//         head: {},
//         main: {
          
//         }
//       }
//     }))
//     CLIENT_CONFIG.plugins.push(new ResourceHintWebpackPlugin())
    
//     // CLIENT_CONFIG.plugins.push(new HtmlWebpackHarddiskPlugin())

//     // external modules should not be embeded in bundles
//     // CLIENT_CONFIG.externals = ['preact', 'preact-compat', 'react', 'react-dom']
//     // CLIENT_CONFIG.externals = {
//     //   React: /react/i,
//     //   render: /react-drom/i,
//     //   lodash : {
//     //     commonjs: "lodash",
//     //     amd: "lodash",
//     //     root: "_" // indicates global variable
//     //   }
//     // }

//     // treating sprites
    // let shouldAddSprites = false
 //     CLIENT_CONFIG.plugins.push(new ExtractTextPlugin("[name].css"))
    
    // }












//     if (IS_DEV) {
//       // CLIENT_CONFIG.plugins.push(new HtmlReloadPlugin())
//     }


















//     // extra optimizations for production environment
//     // (or if enabled for optimization in development mode)

//     // Critical paths
//     CLIENT_CONFIG.plugins.push(new WebpackOnBuildPlugin(function(stats) {
//       critical.generate({
//         inline: true,
//         minify: true,
//         extract: true,
//         timeout: 30000,
//         base: PROJECT_PATH + '/dist/client/',
//         src: 'main/index.html',
//         dest: 'main/index-critical.html',
//         width: 1300,
//         height: 900
//       })
//     }))
//     // treating images
//     CLIENT_CONFIG.plugins.push(new ImageminPlugin({
//       disable: !opts.development.optmizeImages && IS_DEV, // Disabled by default during development
//       optipng: { optimizationLevel: 9 },
//       gifsicle: { optimizationLevel: 3, interlaced: true },
//       jpegtran: { optimizationLevel: 5 },
//       svgo: { optimizationLevel: 5 },
//       webp: { quality: 75 },
//       pngquant: {
//         quality: '65-90',
//         speed: 4
//       },
//       plugins: [
//         imageminMozjpeg({
//           quality: 90
//         }),
//         imageminPngcrush(),
//         // imageminWebp() // for some reason, this is corrupting jpg files :o
//       ]  
//     }))
    // if (FILES_TO_APPEND.length) {
    //   _INCLUDE_ASSETS({ FILES_TO_APPEND }, CLIENT_CONFIG)
    //   // FILES_TO_APPEND.forEach(file => {
    //   //   if (typeof file === 'string' || file.assets && file.assets.length) {
    //   //     CLIENT_CONFIG.plugins.push(new HtmlWebpackIncludeAssetsPlugin({
    //   //       assets: file,
    //   //       append: false
    //   //     }))
    //   //   }
    //   // })
    // }
//     if (opts.client) {
//       if (opts.client.prependFiles) {
//         opts.client.prependFiles.forEach(file => {
//           CLIENT_CONFIG.plugins.push(new HtmlWebpackIncludeAssetsPlugin({
//             assets: file,
//             append: false,
//             silent: true,
//             publicPath: false
//           }))
//         })
//       }
//       if (opts.client.appendFiles) {
//         opts.client.appendFiles.forEach(file => {
//           CLIENT_CONFIG.plugins.push(new HtmlWebpackIncludeAssetsPlugin({
//             assets: file,
//             append: true,
//             publicPath: false
//           }))
//         })
//       }
//     }
//     CLIENT_CONFIG.plugins.push(new StyleLintPlugin({
//       files: ['src/**/*.s?(a|c)ss', 'src/**/*.less'],
//       quiet: true,
//       failOnError: false,
//       emitErrors: false,
//       configFile: path.resolve(PROJECT_PATH, './.further/.stylelintrc.json')
//     }))






























//     // Extra optmizations
//     if (!IS_DEV || opts.development.optimize) {
//       CLIENT_CONFIG.plugins.push(new webpack.LoaderOptionsPlugin({
//         minimize: true
//       }))
//       // CLIENT_CONFIG.plugins.push(new webpack.optimize.CommonsChunkPlugin({
//       //   name: 'polifills',
//       //   filename: 'babel-polyfills',
//       //   // chunks: []
//       // }))
//       // CLIENT_CONFIG.plugins.push(new webpack.optimize.DedupePlugin())
//       CLIENT_CONFIG.plugins.push(new webpack.optimize.AggressiveMergingPlugin())
//       CLIENT_CONFIG.plugins.push(new webpack.optimize.UglifyJsPlugin({
//         minimize: true,
//         test: /\.(js|css)($|\?)/i,
//         include: 'dist',
//         ecma: 8,
//         // include: path.resolve(PROJECT_PATH, 'dist')
//       }))
//       CLIENT_CONFIG.plugins.push(new CompressionPlugin({
//         asset: "[path].gz[query]",
//         algorithm: "gzip",
//         test: /\.(js|css|html|htm)$/,
//         threshold: 10240,
//         minRatio: 0.8
//       }))
//       // CLIENT_CONFIG.plugins.push(new webpack.optimize.minimize())
//       // CLIENT_CONFIG.plugins.push(new webpack.optimize.UglifyJsPlugin({
//       //   minimize: true,
//       //   test: /\.(js|css)($|\?)/i,
//       //   include: 'dist',
//       //   ecma: 8,
//       //   // include: path.resolve(PROJECT_PATH, 'dist')
//       // }))
//     }
    
//     // and let's return the config for the client, merged with the default config
    
  })
}


// ⸨░░░░░░░░░░░░░░░░░░⸩


// WEBPACK FOOTER //
// ./src/configure-client.js